export default __webpack_public_path__ + "static/media/Imagen_variantes_motor.a7a90237.png";